import React from 'react'
import Button from '../buttons/Button'

interface Iprops {
    onConfirm: () => void
    onCancel: () => void
    title: string
}

export default function PopUpGeneric(props: Iprops): React.ReactElement {
    return (
        <div className="popup-mask-background">
            <div className="popup-generic">
                <h2 className="popup-title">{props.title}</h2>
                <div className="popup-box-buttons">
                    <Button type="button" onClick={props.onCancel} placeholder={'Cancelar'} />
                    <Button type="button" onClick={props.onConfirm} placeholder={'Confirmar'} />
                </div>
            </div>
        </div>
    )
}
